import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Row, Card, CardHeader, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getFinalDestinationList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditFinalDestinationModal from './Add_Edit/AddEditFinalDestinationModal';
import DeleteFinalDestination from './Delete/DeleteFinalDestination';
import { getRolesList } from '../../../slices/thunks';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const FinalDestinationsList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorFinalDestinations = createSelector(
		state => state.FinalDestinations,
		finalDestination => ({
			finalDestinationList: finalDestination.finalDestinationList,
			isLoadingList: finalDestination.isLoadingList,
			isFinalDestinationSuccess: finalDestination.isFinalDestinationSuccess,
			error: finalDestination.error,
			isAdding: finalDestination.isAdding,
			isAdded: finalDestination.isAdded,
			isAddError: finalDestination.isAddError,
			isUpdating: finalDestination.isUpdating,
			isUpdated: finalDestination.isUpdated,
			isUpdateError: finalDestination.isUpdateError,
			isDeleting: finalDestination.isDeleting,
			isDeleted: finalDestination.isDeleted,
			isDeleteError: finalDestination.isDeleteError,
		})
	);

	const { finalDestinationList, isLoadingList } = useSelector(
		selectorFinalDestinations
	);

	useEffect(() => {
		dispatch(getFinalDestinationList());
	}, []);

	const [dataFinalDestination, setDataFinalDestination] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete FinalDestination
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = finalDestination => {
		setDataFinalDestination(finalDestination);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = finalDestination => {
		setDataFinalDestination(finalDestination);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'finalDestination',
				columnDefType: 'display',
				 size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const finalDestinationData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(finalDestinationData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const finalDestinationData =
														cellProps.row.original;
													handleClickDelete(finalDestinationData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Tipo', accessorKey: 'final_destination_type.name',  size: 'auto', },
			{ header: 'Nombre', accessorKey: 'name',  size: 'auto' },
			{ header: 'RUT', accessorKey: 'rut',  size: 'auto' },
			{ header: 'Código SINADER', accessorKey: 'code_sinader',  size: 'auto', },
			{ header: 'Dirección', accessorKey: 'address',  size: 'auto' },
			{ header: 'Teléfono', accessorKey: 'phone',  size: 'auto' },
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className="border-0 pb-0">
							<div className="d-flex align-items-end justify-content-end">
								<div className="flex-shrink-0">
									<div className="d-flex flex-wrap gap-2">
									<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataFinalDestination({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Destino Final
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={finalDestinationList || []}
								isLoadingData={isLoadingList}
								nameFile={'destinos_finales'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataFinalDestination({});
											handleToggleModal();
										},
										title: 'Crear Destino Final'
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditFinalDestinationModal
				dataFinalDestination={dataFinalDestination}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteFinalDestination
				dataFinalDestination={dataFinalDestination}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default FinalDestinationsList;
